import React, { useEffect, useState } from 'react';
import { Badge } from 'reactstrap';
import { toast } from 'react-toastify';
import { Link, withRouter } from 'react-router-dom';

import Api from '../../../util/api';
import t, { partial } from '../../../util/translation/translation';
import { formatDateTime } from '../../../util/date-and-time';
import SignIcon from 'mdi-react/SignIcon';

const d = partial('Deals');

const RecentActivities = ({ setLoading, startEndObject }) => {
  const [deals, setDeals] = useState([]);

  const getDeals = async (
    currentPage = 1,
    pageSize = 5,
    orderObject = {
      orderBy: 'madeAt',
      desc: true,
    }
  ) => {
    setLoading(true);
    try {
      const resDeals = await Api.companies.getDeals(
        { page: currentPage, take: pageSize },
        {
          orderBy: orderObject.orderBy,
          direction: orderObject.desc ? 'DESC' : 'ASC',
          startDate: startEndObject.start,
          endDate: startEndObject.end,
        },
        true
      );

      setDeals(resDeals.data);
      setLoading(false);
    } catch (err) {
      toast.error(JSON.stringify(err));
      setLoading(false);
    }
  };

  useEffect(() => {
    getDeals();
  }, [startEndObject]);

  const transactionTypeColor = (type) => {
    switch (type) {
      case 'BOUGHT':
      case 'SOLD':
        return 'success';
      case 'MEETING':
        return 'premium';
      case 'REFERENCE':
        return 'warning';
      default:
        return '';
    }
  };

  const listRecentActivity = () => {
    //MAX 5 Companies
    if (deals.length === 0) {
      return (
        <div className="pt-2">
          <div className="flex justify-center my-2">
            <div
              style={{
                background: '#F4F4F6',
                borderRadius: 12,
                height: 35,
                width: 35,
              }}
            >
              <div
                style={{
                  margin: '6px 8px',
                  height: 18,
                }}
              >
                <SignIcon style={{ width: 18 }} />
              </div>
            </div>
          </div>
          <p className="m-2 block center-text">No data</p>
        </div>
      );
    }
    const getEmployeeName = (deal) => {
      return `${deal?.executorEmployee?.firstName || ''} ${deal?.executorEmployee?.lastName || ''}`;
    };
    return deals.map((deal, i) => (
      <Link
        to={`/companies/edit/${deal.createdByCompanyId}?tab=1`}
        style={{ background: i % 2 ? '#fff' : '#F9FAFB' }}
        key={`topCompanies-${deal.id}`}
        className="flex space-between p-3"
      >
        <div className="flex flex-start">
          <div>
            <span style={{ display: 'block', fontWeight: 600, color: '#000' }}>
              {deal?.createdByCompany?.name}{' '}
              <Badge color={transactionTypeColor(deal.transactionType)}>
                {t(`Deals.${deal.transactionType}`)}
              </Badge>
            </span>
            <span style={{ display: 'block', color: '#98A0AE' }}>
              {getEmployeeName(deal)} {deal.description && '·'}{' '}
              {deal.description?.split('\n')[0]}
            </span>
          </div>
        </div>
        <div>
          <span style={{ display: 'block', color: '#98A0AE' }}>
            {formatDateTime(deal?.madeAt)}
          </span>
        </div>
      </Link>
    ));
  };

  return (
    <>
      <div
        style={{
          paddingBottom: 5,
          background: '#fff',
          borderRadius: 6,
          boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.08)',
        }}
      >
        <div className="p-3 border-bottom">
          <h4>{d('recentActivities')}</h4>
        </div>
        {listRecentActivity()}
      </div>
    </>
  );
};

export default withRouter(RecentActivities);
